module.exports = __webpack_public_path__ + "static/couple-happy-bowls-square.976fa0a3.jpg";